import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import { AccountSafeInputDto, AccountSafeOutputDto, AccountSafeOutputDtoSingleOutputMessage } from '@types';

export const useFetchAccountSafe = (): UseFetchHookOutput<AccountSafeInputDto, AccountSafeOutputDto> => {
	const { accountSafe: fetchAccountSafe } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<AccountSafeInputDto, AccountSafeOutputDto>({
		input: {
			fetchFn: fetchAccountSafe,
			onSuccess: (res: AccountSafeOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ accountSafe: res.data });
			},
		},
		requestName: 'account/safe',
	});
};
